// import MainLayout from 'layout/MainLayout';
// import MinimalLayout from 'layout/MinimalLayout';
// import HeaderLayout from 'layout/HeaderLayout';
import React from 'react';
import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// project imports

// import { Test } from 'views/admin-components/pages/Test';
// import LandingTestPage from 'views/user-components/LandingTestPage';
// import Home from 'views/user-components/pages/dashboard/Home';
// import ProfileFinalStep from 'views/user-components/pages/signup-profile/ProfileFinalStep';


import Loadable from 'ui-component/Loadable';

// const ProfileSteps = Loadable(lazy(() => import('views/user-components/pages/signup-profile/ProfileSteps')));
// const Test = Loadable(lazy(() => import('views/admin-components/pages/Test')));
const DashBoardLayout = Loadable(lazy(() => import('layout/DashboardLayout')));
const Home = Loadable(lazy(() => import('views/user-components/pages/dashboard/Home')));
const AssetAllocation = Loadable(lazy(() => import('views/user-components/pages/dashboard/AssetAllocation')));
const AssetAllocationHome = Loadable(lazy(() => import('views/user-components/pages/dashboard/AssetAllocationMain')));
const EmployeeInfo = Loadable(lazy(() => import('views/user-components/pages/dashboard/EmployeeInfo')));
const MessageCenter = Loadable(lazy(() => import('views/user-components/pages/dashboard/MessageCenter')));
const Personal = Loadable(lazy(() => import('views/user-components/pages/dashboard/Personal')));
const Goals = Loadable(lazy(() => import('views/user-components/pages/dashboard/Goals')));
const Accounts = Loadable(lazy(() => import('views/user-components/pages/dashboard/Accounts')));
const Assets = Loadable(lazy(() => import('views/user-components/pages/dashboard/Assets')));
const IncomeExpenses = Loadable(lazy(() => import('views/user-components/pages/dashboard/IncomeExpenses')));
const EstatePlanning = Loadable(lazy(() => import('views/user-components/pages/dashboard/EstatePlanning')));
const Fees = Loadable(lazy(() => import('views/user-components/pages/dashboard/Fees')));
const AssetAllocationAccounts = Loadable(lazy(() => import('views/user-components/pages/dashboard/AssetAllocationAccounts')));

const AccountSummary = Loadable(lazy(() => import('views/user-components/pages/dashboard/AccountSummary')));
const CashFlow = Loadable(lazy(() => import('views/user-components/pages/dashboard/CashFlow')));
const NetWorth = Loadable(lazy(() => import('views/user-components/pages/dashboard/NetWorth')));
const FundTransfer = Loadable(lazy(() => import('views/user-components/pages/dashboard/FundTransfer')));
const DataVault = Loadable(lazy(() => import('views/user-components/pages/dashboard/DataVault')));
const AssetDrift = Loadable(lazy(() => import('views/user-components/pages/dashboard/AssetDrift')));
const ProjectedCashFlow = Loadable(lazy(() => import('views/user-components/pages/dashboard/ProjectedCashFlow')));
const ProjectedNetWorth = Loadable(lazy(() => import('views/user-components/pages/dashboard/ProjectedNetWorth')));
const InsuranceCalculator = Loadable(lazy(() => import('views/user-components/pages/dashboard/InsuranceCalculator')));
const FinancialGoal = Loadable(lazy(() => import('views/user-components/pages/dashboard/FinancialGoal')));
const ThankYouPage = Loadable(lazy(() => import('views/user-components/pages/ThankYouPage')));

const loginType = localStorage.getItem('type');
const isDashboardLogin = loginType === '2' || loginType === '5' ? true : false

const partnerName = localStorage.getItem('partner_url');

const ClientRoutes = {
    path: '/',
    // THIS IS TEMP SOLUTION FOR SIGNUP FORM AFTER FIRST TIME LOGIN. FOR MORE CHECK NOTE BOOKS TO HOW TO SETUP.
    element: isDashboardLogin ? <DashBoardLayout /> : <Navigate to={`${partnerName}/signin`} />,
    children: [
        // todo: send it to main landing page in else condition.
        // { path: '/signup/profile/:userid', element: isDashboardLogin ? <ProfileSteps /> : <Navigate to={`/smartmoney/signin`} /> }, //NAVIGATE({ TO, REPLACE, STATE }
        { path: '/home', element: isDashboardLogin ? <Home /> : <Navigate to={`/smartmoney/signin`} /> },
        { path: '/employee_info', element: isDashboardLogin ? <EmployeeInfo /> : <Navigate to={`/smartmoney/signin`} /> },
        { path: '/personal', element: isDashboardLogin ? <Personal /> : <Navigate to={`/smartmoney/signin`} /> },
        { path: '/assetallocation', element: isDashboardLogin ? <AssetAllocation /> : <Navigate to={`/smartmoney/signin`} /> },
        { path: '/main', element: isDashboardLogin ? <AssetAllocationHome /> : <Navigate to={`/smartmoney/signin`} /> },
        { path: '/asset_allocation_accounts', element: isDashboardLogin ? <AssetAllocationAccounts /> : <Navigate to={`/smartmoney/signin`} /> },
        { path: '/goals', element: isDashboardLogin ? <Goals /> : <Navigate to={`/smartmoney/signin`} /> },
        { path: '/accounts', element: isDashboardLogin ? <Accounts /> : <Navigate to={`/smartmoney/signin`} /> },
        { path: '/assets', element: isDashboardLogin ? <Assets /> : <Navigate to={`/smartmoney/signin`} /> },
        { path: '/fees', element: isDashboardLogin ? <Fees /> : <Navigate to={`/smartmoney/signin`} /> },
        { path: '/fund_transfer', element: isDashboardLogin ? <FundTransfer /> : <Navigate to={`/smartmoney/signin`} /> },
        { path: '/income_expenses', element: isDashboardLogin ? <IncomeExpenses /> : <Navigate to={`/smartmoney/signin`} /> },
        { path: '/estate_planning', element: isDashboardLogin ? <EstatePlanning /> : <Navigate to={`/smartmoney/signin`} /> },
        // REPORT
        { path: '/account_summary', element: isDashboardLogin ? <AccountSummary /> : <Navigate to={`/smartmoney/signin`} /> },
        { path: '/cashflow', element: isDashboardLogin ? <CashFlow /> : <Navigate to={`/smartmoney/signin`} /> },
        { path: '/networth', element: isDashboardLogin ? <NetWorth /> : <Navigate to={`/smartmoney/signin`} /> },
        { path: '/data_vault', element: isDashboardLogin ? <DataVault /> : <Navigate to={`/smartmoney/signin`} /> },
        { path: '/message_center', element: isDashboardLogin ? <MessageCenter /> : <Navigate to={`/smartmoney/signin`} /> },
        { path: '/asset_drift', element: isDashboardLogin ? <AssetDrift /> : <Navigate to={`/smartmoney/signin`} /> },
        // FINANCIAL PLAN
        { path: '/projected_cash_flow', element: isDashboardLogin ? <ProjectedCashFlow /> : <Navigate to={`/smartmoney/signin`} /> },
        { path: '/projected_net_worth', element: isDashboardLogin ? <ProjectedNetWorth /> : <Navigate to={`/smartmoney/signin`} /> },
        { path: '/insurance_calculator', element: isDashboardLogin ? <InsuranceCalculator /> : <Navigate to={`/smartmoney/signin`} /> },
        { path: '/financial_goals', element: isDashboardLogin ? <FinancialGoal /> : <Navigate to={`/smartmoney/signin`} /> },

        { path: '/thanks', element: isDashboardLogin ? <ThankYouPage /> : <Navigate to={`/smartmoney/signin`} /> }
    ]
};

export default ClientRoutes;
